import type { EnvHealthAlert } from '@customerio/hydra-ui-api';

// Default poll cadence for workspace-health-page endpoints (campaigns, segments,
// push, broadcasts, delay history, objects, events, attributes, tasks). Each of
// these has its own backend route and cache; bump cautiously, only matching the
// slowest backend cache TTL the constant is paired with.
export const WORKSPACE_HEALTH_REFETCH_INTERVAL_ACTIVE = 120_000; // 2 minutes
// Specific to the heavy /v1/environments/:env/health endpoint. Matches its
// 5-min backend ResponseCache TTL — anything shorter pays the full Prometheus
// cost on every cache miss. See useEnvHealth (which also consults the
// `next_refresh_at` hint on the response to align with the cache boundary).
export const ENV_HEALTH_REFETCH_INTERVAL_ACTIVE = 300_000; // 5 minutes
// Lightweight off-page health check interval (used by nav widget / home banner).
export const WORKSPACE_HEALTH_CHECK_INTERVAL = 60_000; // 1 minute

/**
 * Where a customer checks whether a delay we have owned is an incident.
 *
 * One constant because two surfaces now point at it — a row's own note and the remainder line
 * under a throttle — and a status link that disagreed with itself would be worse than none.
 */
export const STATUS_PAGE_URL = 'https://status.customer.io';

export const DATA_ALERT_SEVERITY_RANK: Record<EnvHealthAlert['severity'], number> = {
  error: 0,
  caution: 1,
  info: 2,
};
